module.exports = __webpack_public_path__ + "img/archive.a20c04eb.svg";